module.exports = {"id":"positional-distribution","title":"Variant positional distribution","content":"<h1>Positional distribution plot</h1>\n<p>todo</p>\n"}